import React, {useEffect, useState} from "react";
import {Outlet, useLocation} from "react-router";
import Footer from "../components/Footer";
import Header from "../components/Header";
import WelcomBack from "../components/Home/WelcomBack";
import {SECTION} from "../constants/storage";
import {isSegmentInPath} from "../helpers/stringHelpers";
import useFooterVisibility from "../hooks/useFooterVisibility";
import {routerPaths} from "../utils/routerPaths";

const SKIP_LAYOUT = [routerPaths.completion];

const Layout = () => {
    const location = useLocation();
    const {shouldHideHeader} = useFooterVisibility();

    const [welcomBack, setWelcomBack] = useState(false);

    // Check if any SKIP_LAYOUT item exists in the pathname with word boundaries
    const shouldSkipLayout = SKIP_LAYOUT.some((skipPath) =>
        isSegmentInPath(skipPath, location.pathname)
    );

    const handleWelcomBack = () => {
        setWelcomBack((prev) => !prev);
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const section = urlParams.get(SECTION);
        if (section) {
            handleWelcomBack();
        }
    }, []);

    return (
            <div className="root_container">
                {!shouldSkipLayout && !shouldHideHeader && <Header/>}
                <Outlet/>
                {!shouldSkipLayout && <Footer/>}
                {welcomBack && (
                    <WelcomBack
                        open={welcomBack}
                        handleOpen={handleWelcomBack}
                        handleClose={handleWelcomBack}
                    />
                )}
            </div>
    );
};

export default Layout;
